<script>
import baseMixin from '@/mixins/baseMixin'
import OverviewStatsDto from '@/models/overview/overviewStatsDto'
import { isNonEmptyArray } from '@/helpers/array-helpers'
import ClientGroupOverviewFillRateChart from './client-group-overview-fill-rate-chart.vue'

export default {
  name: 'ClientGroupOverviewStatisticsContainer',
  components: { ClientGroupOverviewFillRateChart },
  mixins: [baseMixin],
  props: {
    overviewData: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    hasOverviewData() {
      return isNonEmptyArray(this.overviewData)
    },
    calcTotalOpenBookings() {
      if (!this.hasOverviewData) return 0
      return this.overviewData.reduce((a, e, i) => {
        a += e.openBookings
        return a
      }, 0)
    },
    calcTotalBookings() {
      if (!this.hasOverviewData) return 0
      return this.overviewData.reduce((a, e, i) => {
        a += e.totalBookings
        return a
      }, 0)
    },
    compOverviewStats() {
      if (!this.hasOverviewData) return null

      return new OverviewStatsDto({
        openBookings: this.calcTotalOpenBookings,
        totalBookings: this.calcTotalBookings,
      })
    },
    compFilledBookings() {
      if (!this.hasOverviewData) return 0
      return this.compOverviewStats.filled
    },
    compUnfilledBookings() {
      if (!this.hasOverviewData) return 0
      return this.compOverviewStats.unfilled
    },
    compTotalBookings() {
      if (!this.hasOverviewData) return 0
      return this.compOverviewStats.totalBookings
    },
  },
}
</script>

<template>
  <section class="d-flex justify-end align-center" style="height: 150px">
    <div class="text-center" width="150px">
      <header class="mb-4">
        {{ $t('clientGroupOverview.stats.totalFilledLabel') }}
      </header>

      <p class="text-h4 mb-0 text-center">{{ compFilledBookings }}</p>
    </div>

    <div class="text-center ml-8" width="150px">
      <header class="mb-4">
        {{ $t('clientGroupOverview.stats.totalOpenLabel') }}
      </header>

      <p class="text-h4 mb-0 text-center">{{ compUnfilledBookings }}</p>
    </div>

    <div class="text-center ml-8" width="150px">
      <header class="mb-4">
        {{ $t('clientGroupOverview.stats.totalBookingsLabel') }}
      </header>

      <h4 class="text-h4 mb-0">{{ compTotalBookings }}</h4>
    </div>

    <ClientGroupOverviewFillRateChart
      class="ml-8"
      :overview-stats="compOverviewStats"
      style="width: 150px"
    />
  </section>
</template>
